import { Component, Input } from '@angular/core';
import { BaseButtonComponent } from '../../Base/base-button.component';

@Component({
  selector: 'ds-primary-icon-button',
  templateUrl: './primary-icon-button.component.html',
  styleUrls: ['./primary-icon-button.component.scss'],
})
export class PrimaryIconButtonComponent extends BaseButtonComponent {
  @Input() public icon = '';
}
